import { SESSION_STORAGE } from '../constants/sessionStorage'
import { getCookie } from '../utils/getCookies'
import { setCookies } from '../utils/setCookies'
import { DV } from './development'
import { PR } from './production'

const authCookies = getCookie('auth')

export const ENV = () => {
  if (process.env.NODE_ENV === 'development') {
    return DV
  } else {
    return PR
  }
}

// TODO: This if is only used to mode development, it's not be used in production
export const USER_MODE_DEV =
  process.env.NODE_ENV === 'development'
    ? {
        username: 'luis.miguelgoncalves@ageas.pt',
        produtoid: 'Petis',
        environment: 'TS',
        token: authCookies,
      }
    : {
        username: '',
        produtoid: '',
        environment: '',
        token: '',
      }

if (process.env.NODE_ENV === 'development') {
  sessionStorage.setItem(
    SESSION_STORAGE.contextSelectedArray,
    JSON.stringify(['Agent', '8001', 1, false]),
  )
  // Manter comentado para testes em desenvolvimento
  // sessionStorage.setItem(
  //   SESSION_STORAGE.NPANavigationClientContext,
  //   JSON.stringify({
  //     refNumber: '208232974',
  //     data: {
  //       nif: '208232974',
  //       policyNumber: '',
  //       clientName: 'N_2_6104757 A1_6104757',
  //       clientAddress: '',
  //       clientEmail: 'baasd@a.com',
  //       clientEmailId: '',
  //       clientTelephone: '965643532',
  //       clientEntityID: '13864862',
  //       clientFixedphone: '',
  //       clientAllowPaperless: false,
  //       clientMaritalStatus: null,
  //       clientBirthDate: '1977-07-26T00:00:00',
  //       clientJob: '',
  //       clientJobID: '',
  //     },
  //   }),
  // )
  setCookies('pts_username', USER_MODE_DEV.username || '')
}
